import React from "react";

const Chapter6 = () => {
  return (
    <>
      <h2>When are the most metals present?</h2>
      <p>
        Amounts of metals and trace elements are highest during the spring and
        summer. Snowmelt and rain carry these elements to streams and rivers as
        the water runs over rock, sediment, urban areas, mining facilities, and
        other sources of metals and trace elements. Variation in metals and
        trace elements is much smaller than other contaminants. Some of these
        elements are mostly always in our waterways, and others are almost never
        at noticeable levels.
      </p>
    </>
  );
};

export default Chapter6;
